<template>
  <div v-if="isShow.isPHShow" class="pg3">
    <div class="progress-bar-wp">
      <div class="progress-text">文明昌江人必做的100件事</div>
      <div class="progress-text">你完成了{{ sendList.length }}件哦~</div>
      <div class="progress-bar">
        <div class="progress-bar-inner" :style="`width: ${loadingNum}%;`"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageThree',
  props: {
    isShow: Object,
    sendList: Array,
  },
  data() {
    return {
      loadingNum: 0,
      completed: 3,
    }
  },
  methods: {
    showNext() {
      setTimeout(() => {
        this.$emit('nextPage', 'isPFShow')
      }, 200)
    },
    progress() {
      let timerId = setInterval(() => {
        this.loadingNum += 1
        if (this.loadingNum === 100) {
          clearInterval(timerId)
          this.showNext()
        }
      }, 10)
    },
  },
  watch: {
    'isShow.isPHShow': function () {
      this.progress()
    },
  },
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg3 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #ffe400;
}
.progress-bar-wp {
  margin-bottom: 14rem;
}
.progress-bar {
  box-sizing: border-box;
  height: 0.625rem /* 10/16 */;
  width: 35/2rem /* 560/16 */;
  border: 1px solid #1a1a1a;
  border-radius: 0.375rem /* 6/16 */;
  // padding: 0.125rem /* 2/16 */;
  margin: 2rem /* 32/16 */ 0;
}
.progress-bar-inner {
  height: 100%;
  background: linear-gradient(to bottom, #ffac01 1%, #ff870b 50%, #ff5e15 100%);
  border-radius: 0.25rem /* 4/16 */;
}
.progress-text {
  text-align: center;
  color: #333;
  font-weight: bold;
  font-size: 0.875rem /* 14/16 */;
  line-height: 1.4;
}
</style>
